module.exports = __webpack_public_path__ + "img/shop1-1.c39363a0.png";